<template>
    <div style="position: absolute;left: 42%;top:45%;color:black;font-size: 26px;">
      正在返回考试列表页......
    </div>
</template>

<style>

</style>

<script>
  localStorage.setItem('timemillions', new Date());
  window.setInterval(() => {
    var path = window.location.pathname;
    if(path == "/examInfo"){
      var newUrl = window.location.protocol+"//"+window.location.host+"/MyExam";
      window.location.href =newUrl;
    }
  },3000)
</script>



// WEBPACK FOOTER //
// src/views/ExamInfo.vue